<template>
  <div :id="`duHolder_${duid}`" />
</template>
<script>
import 'babel-polyfill'
import 'es6-promise/auto'
import { toServiceDomain } from '@/api/serviceDomain'

export default {
  name: 'DEXT5Upload',
  props: {
    single: { type: Boolean, default: false, required: false },
    category: { type: Boolean, default: false, required: false },
    id: { type: String, default: '', required: false },
    width: { type: String, default: '100%', required: false },
    height: { type: String, default: '200px', required: false },
    fileInfo: { type: Array, required: false },
    categoryInfo: { type: Array, required: false },
    fileExt: { type: String, default: '', required: false },
    fileSize: { type: String, default: '', required: false },
    buttonBarEdit: { type: Boolean, default: false, required: false }
  },
  data () {
    return {
      index: 0,
      makeDext: false,
      options: {},
      uploadingYn: 'N',
      dext5Instance: null,
      duid: `${this.id}_du_${Math.random().toString(36).substr(2, 9)}`
    }
  },
  watch: {
    fileInfo: function () {
      //
    }
  },
  destroyed () {
    if (DEXT5UPLOAD.GetUploadByName(this.options.id)) {
      DEXT5UPLOAD.Destroy(this.options.id)
    }
    DEXT5UPLOAD.config.MaxOneFileSize = ''
  },
  mounted () {
    let handlerUrl = ''
    const commonUrl = toServiceDomain(process.env.VUE_APP_COMMON_URL)
    if (commonUrl.startsWith('http')) {
      handlerUrl = commonUrl
    } else if (commonUrl.startsWith('//')) {
      handlerUrl = location.protocol + commonUrl
    }
    handlerUrl += '/commons/dext5/handler'

    let buttonBarEditValue
    if (this.buttonBarEdit) {
      buttonBarEditValue = 'download'
    } else {
      buttonBarEditValue = 'add,download,remove,remove_all'
    }

    const duOptions = Object.assign(this.options, {
      type: this.type,
      id: this.duid,
      fileExt: this.fileExt,
      fileSize: this.fileSize,
      lang: this.$i18n.locale.toLowerCase(),
      width: this.width || '100%',
      height: this.height || '500px',
      uploadHolder: 'duHolder_' + this.duid,
      handlerUrl: handlerUrl,
      runtimes: 'html5',
      buttonBarEdit: buttonBarEditValue,
      event: {
        CreationComplete: this.onCreationComplete,
        TransferComplete: this.onTransferComplete,
        BeforeFileDownload: this.beforeFileDownload,
        FinishDownloaded: this.FinishDownloaded,
        AfterAddItemEndTime: this.AfterAddItemEndTime,
        AfterAddItem: this.AfterAddItem,
        BeforeDeleteItem: this.BeforeDeleteItem,
        BeforeAddItem: this.BeforeAddItem,
        UploadBegin: this.UploadBegin,
        UploadCompleted: this.UploadCompleted
      }
    })

    if (typeof (DEXT5UPLOAD) === 'undefined') {
      this.$loadScript('/dext5upload/js/dext5upload.js')
        .then(() => {
          this.MakeUpload(duOptions)
        })
        .catch(() => {
          console.log('load fail catch')
        })
    } else {
      this.MakeUpload(duOptions)
    }
  },
  methods: {
    suppressDextLicenseAlert () {
      if (window.__dextAlertPatched) return
      window.__dextAlertPatched = true

      const origAlert = window.alert
      window.__dextOrigAlert = origAlert
      const keywords = [
        '라이센스', 'License', '만료', '도메인',
        'product_key', 'license_key', 'expire', 'Expire'
      ]
      window.alert = function (msg) {
        const text = String(msg || '')
        if (keywords.some(k => text.includes(k))) {
          console.warn('[DEXT5 license alert suppressed]', text)
          return
        }
        return origAlert.apply(window, arguments)
      }

      // 라이센스 alert는 초기화 시점에만 발생 → 일정 시간 후 원본 복구
      setTimeout(() => this.restoreDextAlert(), 5000)
    },
    restoreDextAlert () {
      if (!window.__dextAlertPatched) return
      if (window.__dextOrigAlert) {
        window.alert = window.__dextOrigAlert // 원본 alert 복구
        delete window.__dextOrigAlert
      }
      window.__dextAlertPatched = false
    },
    ResetDext: function () {
      DEXT5UPLOAD.Destroy(this.options.id)
      // this.MakeUpload(this.options)
    },
    MakeUpload: function (options) {
      this.suppressDextLicenseAlert()
      if (DEXT5UPLOAD.GetUploadByName(options.id)) {
        DEXT5UPLOAD.Destroy(options.id)
      }

      options = {
        ...this.options,
        ...options
      }

      if (options.fileExt) {
        DEXT5UPLOAD.config.ExtensionAllowOrLimit = '1'
        DEXT5UPLOAD.config.ExtensionArr = options.fileExt
      }

      if (options.fileSize) {
        DEXT5UPLOAD.config.MaxOneFileSize = options.fileSize
      }

      DEXT5UPLOAD.config.Width = options.width
      DEXT5UPLOAD.config.Height = options.height
      DEXT5UPLOAD.config.Runtimes = options.runtimes
      DEXT5UPLOAD.config.Lang = options.lang
      DEXT5UPLOAD.config.Event = options.event
      DEXT5UPLOAD.config.UploadHolder = options.uploadHolder
      DEXT5UPLOAD.config.ButtonBarEdit = options.buttonBarEdit
      DEXT5UPLOAD.config.UseViewOrOpenEvent = '0'
      if (this.category) {
        DEXT5UPLOAD.config.HeaderBarItem = this.$t('comp.901')
        DEXT5UPLOAD.config.HeaderBarItemWidth = '200'
        DEXT5UPLOAD.config.HeaderBarItemAlign = 'center'
      } else {
        DEXT5UPLOAD.config.HeaderBarItem = null
      }

      if (options.handlerUrl !== '') {
        DEXT5UPLOAD.config.HandlerUrl = options.handlerUrl
      }

      this.dext5Instance = new Dext5Upload(options.id) // NOSONAR: constructor registers the instance via side effect
    },
    SendFile: function () {
      // DEXT5UPLOAD.AddUploadedFile('test', originName, path, size, customValue, this.Id)
      DEXT5UPLOAD.Transfer(this.id)
    },
    afterCompose: function (uploadId) {
      const frameDoc = DEXT5UPLOAD.GetUploadByName(uploadId).frameWin.document
      const fileList = frameDoc.getElementById('file_list')
      if (!fileList) return

      Array.from(fileList.children).forEach((v, i) => {
        v.querySelectorAll('ul > li > span').forEach(span => {
          span.addEventListener('dblclick', e => e.stopPropagation())
        })

        if (this.category) {
          const customHeaderObj = v.querySelectorAll('ul > li')[3]?.querySelector('span')
          if (!customHeaderObj) return

          customHeaderObj.style.textAlign = 'center'
          customHeaderObj.textContent = ''

          const tempSelect = document.createElement('select')
          tempSelect.id = this.fileInfo[i].guid
          tempSelect.style.width = '99%'
          tempSelect.style.height = '15px'
          const fileInfo = this.fileInfo
          tempSelect.onchange = function () {
            fileInfo[i].category = this.value
          }
          customHeaderObj.appendChild(tempSelect)

          if (!this.fileInfo[i].category) {
            const opt = document.createElement('option')
            opt.value = ''
            opt.textContent = this.$t('comp.902')
            opt.selected = true
            tempSelect.appendChild(opt)
          }

          this.categoryInfo.forEach(c => {
            const opt = document.createElement('option')
            opt.value = c.value
            opt.textContent = c.category
            opt.selected = c.value === this.fileInfo[i].category
            tempSelect.appendChild(opt)
          })
        }
      })
    },
    // DEXT5 Upload Event
    onCreationComplete: function (uploadId) {
      this.fileInfo.forEach(f => {
        DEXT5UPLOAD.AddUploadedFile(this.index, f.originalName, '/', f.size, f.fileId, uploadId)
        DEXT5UPLOAD.SetUploadedFile(this.index, f.guid, f.originalName, '/', f.size, f.fileId, uploadId)
        this.index = this.index + 1
      })

      this.afterCompose(uploadId)

      this.makeDext = true
    },
    AfterAddItem: function (uploadID, strFileName, nFileSize, nAddItemIndex, objFile) {
      this.uploadingYn = 'Y'
    },
    onTransferComplete: function (uploadId) {
      let jsonAll = DEXT5UPLOAD.GetAllFileListForJson(uploadId)

      let originalName = jsonAll.newFile.originalName
      let size = jsonAll.newFile.size
      let guid = jsonAll.newFile.guid
      let fileId = jsonAll.newFile.responseCustomValue
      let status = jsonAll.newFile.status
      let contentType = jsonAll.newFile.mimeType
      for (let i = 0; i < originalName.length; i++) {
        let equalYn = false
        for (const fileItem of this.fileInfo) {
          if (fileItem.originalName === originalName[i]) {
            console.log('onTransferComplete originalName >>', originalName[i])
            equalYn = true
          }
        }
        if (equalYn === false) {
          console.log('onTransferComplete PUSH >>', originalName[i])
          this.fileInfo.push({
            guid: guid[i],
            originalName: originalName[i],
            size: size[i],
            fileId: fileId[i],
            status: status[i],
            contentType: contentType[i],
            category: '',
            new: true,
            newFlag: 'Y'
          })
          DEXT5UPLOAD.SetUploadedFile(this.index, guid[i], originalName[i], '/', size[i], fileId[i], uploadId)
          this.index = this.index + 1
        }
      }

      this.afterCompose(uploadId)
      this.$emit('completed', this.fileInfo)
      this.uploadingYn = 'N'
    },
    beforeFileDownload: function (uploadID, nWebFile, strItemKey, strItemOrgName, strItemUrlOrPath, largeFiles, isLastEvent) {
      return true
    },
    FinishDownloaded: function (uploadID, nDownloadItemCount) {
      //
    },
    AfterAddItemEndTime: function (uploadID) {
      DEXT5UPLOAD.TransferEx(uploadID)
    },
    BeforeAddItem: function (uploadID, strFileName, nFileSize, nAddItemIndex, strFileLocalPath, objFile) {
      if (this.single) {
        let count = DEXT5UPLOAD.GetTotalFileCount(uploadID)
        if (count > 1 || nAddItemIndex > 1) {
          this.$ekmtcCommon.alertDefault(this.$t('common.FILE_UPLOAD.012'))
          return false
        }
      }
    },
    BeforeDeleteItem: function (uploadID, strWebFile, strItemKey, strItemUrlOrPath, nDeleteItemIndex) {
      for (let i = 0; i < this.fileInfo.length; i++) {
        if (i + 1 === nDeleteItemIndex) {
          this.fileInfo.splice(i, 1)
        }
      }
      // this.$emit('update', this.fileInfo)
    },
    UploadBegin: function () {
      //
    },
    UploadCompleted: function () {
      //
    },
    getFileInfo: function () {
      return this.fileInfo
    },
    deleteAll: function () {
      DEXT5UPLOAD.DeleteAllFile(this.options.id)
    },
    setFileInfo: function () {
      if (this.makeDext) {
        this.fileInfo.forEach(f => {
          DEXT5UPLOAD.AddUploadedFile(this.index, f.originalName, '/', f.size, f.fileId, this.options.id)
          DEXT5UPLOAD.SetUploadedFile(this.index, f.guid, f.originalName, '/', f.size, f.fileId, this.options.id)
          this.index = this.index + 1
        })

        this.afterCompose(uploadId)
      }
    },
    isUploading () {
      return this.uploadingYn === 'Y'
    }
  }
}
</script>
